###*
  * Encapsulates interaction with daterangepicker
  * Used by SettingsManager
###

class INTENT.report.SettingsPeriodManager

  constructor: (@parent) ->
    @code = @parent.code + '-period'
    @attr = @parent.attr + '-period'
    @controller = @parent.controller
    @language = @controller.get_language()
    @el = $ "[#{@attr}]"

    @date_format = 'YYYY-MM-DD'
    @labels =
      'today': __('daterangepicker.today')
      'yesterday': __('daterangepicker.yesterday')
      'this_week_sun_this_day':__('daterangepicker.this_week_sun_this_day')
      'this_week_mon_this_day': __('daterangepicker.this_week_mon_this_day')
      'last_7_days': __('daterangepicker.last_7_days')
      'last_week_sun_sat': __('daterangepicker.last_week_sun_sat')
      'last_week_mon_sun': __('daterangepicker.last_week_mon_sun')
      'last_week_work_mon_fri': __('daterangepicker.last_week_work_mon_fri')
      'last_14_days': __('daterangepicker.last_14_days')
      'last_30_days': __('daterangepicker.last_30_days')
      'this_month': __('daterangepicker.this_month')
      'last_month': __('daterangepicker.last_month')
      'custom_range': __('daterangepicker.custom_range')

    @dates =
      today:
        label: @labels['today']
        value: [moment().tz($('#timezone').val()), moment().tz($('#timezone').val())]
      yesterday:
        label: @labels['yesterday'],
        value: [moment().tz($('#timezone').val()).subtract(1, 'days'), moment().tz($('#timezone').val()).subtract(1, 'days')]
      this_week_sun_this_day:
        label: @labels['this_week_sun_this_day']
        value: [moment().tz($('#timezone').val()).startOf('week'), moment().tz($('#timezone').val())]
      this_week_mon_this_day:
        label: @labels['this_week_mon_this_day']
        value: [moment().tz($('#timezone').val()).startOf('week').add(1, 'days'), moment().tz($('#timezone').val())]
      last_7_days:
        label: @labels['last_7_days']
        value: [moment().tz($('#timezone').val()).subtract(6, 'days'), moment().tz($('#timezone').val())]
      last_week_sun_sat:
        label: @labels['last_week_sun_sat']
        value: [moment().tz($('#timezone').val()).subtract(1, 'week').startOf('week'), moment().tz($('#timezone').val()).subtract(1, 'week').endOf('week')]
      last_week_mon_sun:
        label: @labels['last_week_mon_sun']
        value: [moment().tz($('#timezone').val()).subtract(1, 'week').startOf('week').add(1, 'days'), moment().tz($('#timezone').val()).subtract(1, 'week').endOf('week').add(1, 'days')]
      last_week_work_mon_fri:
        label: @labels['last_week_work_mon_fri']
        value: [moment().tz($('#timezone').val()).subtract(1, 'week').startOf('week').add(1, 'days'), moment().tz($('#timezone').val()).subtract(1, 'week').endOf('week').subtract(1, 'days')]
      last_14_days:
        label: @labels['last_14_days']
        value: [moment().tz($('#timezone').val()).subtract(13, 'days'), moment().tz($('#timezone').val())]
      this_month:
        label: @labels['this_month']
        value: [moment().tz($('#timezone').val()).startOf('month'), moment().tz($('#timezone').val()).endOf('month')]
      last_30_days:
        label: @labels['last_30_days']
        value: [moment().tz($('#timezone').val()).subtract(29, 'days'), moment().tz($('#timezone').val())]
      last_month:
        label: @labels['last_month']
        value: [moment().tz($('#timezone').val()).subtract(1, 'month').startOf('month'), moment().tz($('#timezone').val()).subtract(1, 'month').endOf('month')]

    @init_daterangepicker()

  get_periods: () =>
    @dates

  get_ranges: () =>
    ranges = []
    for code, item of @dates
      ranges[item.label] = item.value

    return ranges

  init_daterangepicker: () =>
    options =
      ranges: @get_ranges()
      startDate: moment().subtract(29, 'days')
      endDate: moment()
      timePicker: false
      format: @date_format
      locale:
        format: @date_format
        applyLabel: __('daterangepicker.applyLabel')
        cancelLabel: __('daterangepicker.cancelLabel')
        fromLabel: __('daterangepicker.fromLabel')
        toLabel: __('daterangepicker.toLabel')
        customRangeLabel: __('daterangepicker.custom_range')
        daysOfWeek: moment().locale(@language).localeData()._weekdaysMin.slice()
        monthNames: moment().locale(@language).localeData()._monthsShort.slice()
        firstDay: 1

    try
      @el.daterangepicker options
    catch e
      console.error e

  get_period_by_dates: (start, end) =>
    period = 'custom_range'
    _.each @dates, (pData, name) =>
      value = _.map pData.value, (moment)=>
        moment.tz($('#timezone').val()).format @date_format
      if _.isArray(value) and start == value[0] and end == value[1]
        period = name
    period

  set_period: (period_code) =>
    period = @dates[period_code]
    if period? and _.isArray(period.value)
      @current_period = period_code
      @set_start_date period.value[0]
      @set_end_date period.value[1]

  set_start_date: (date) =>
    if date?
      @el.data('daterangepicker').setStartDate date

  set_end_date: (date) =>
    if date?
      @el.data('daterangepicker').setEndDate date

  get_start_date: () =>
    @el.data('daterangepicker').startDate.format @date_format

  get_end_date: () =>
    @el.data('daterangepicker').endDate.format @date_format
